<template>
	<div class="container">
		<div class="top_title">
			<router-link v-if="dialog!='Y'" class="icon_back" :to="{name:'H050020',params:{id:info.I_BOOK_NO_SYS,searchInput:searchInput,I_LEVEL_CODE:I_LEVEL_CODE,I_FLAG:I_FLAG,tabFlag:tabFlag}}"
			 tag="span"></router-link>
			<p>{{info.I_TITLE_1}}</p>
			<span style="float: right;position: absolute;top: 0;right: 0.6rem;">
				<span v-if="I_BOOK_VIDEO != ''" class="play_btn icon_top_play" @click="clickAudio(-2)"></span>
				<audio v-if="I_BOOK_VIDEO != ''" id="audio_top" :src="I_BOOK_VIDEO" style="display: none;"></audio>
				{{info.I_PAGE_INDEX}}</span>
		</div>
		<div class="scroll_area" style="overflow-y: auto">
			<!--<div class="banner" :style="{ 'background-image': 'url(' + info.I_PAGE_IMG + ')' }"></div>-->
			<div class="banner"><img :src="info.I_PAGE_IMG" /></div>
			<div class="items" style="overflow-y: auto">
				<div v-for="item,index in info.dataList" class="item">
					<!--<span v-if="item.I_SECTION_VIDEO != ''" class="play_btn icon_play" @click="clickAudio(index)"></span>-->
					<!--<audio v-if="item.I_SECTION_VIDEO != ''" :id="'audio_' + index" :src="item.I_SECTION_VIDEO" style="display: none;"></audio>-->
					<p>{{item.I_SECTION_EN}}</p>
					<p>{{item.I_SECTION_CH}}</p>
				</div>
			</div>
		</div>

		<div class="bottom_part">
			<span class="prePage" v-if="info.I_BUTTON_1!=''" @click="clickPre(info.I_BUTTON_1)">{{info.I_BUTTON_1}}</span>
			<span v-if="I_PAGE_VIDEO != ''" class="play_btn icon_all_play active" @click="clickAudio(-1)"></span>
			<audio v-if="I_PAGE_VIDEO != ''" id="audio_00" :src="I_PAGE_VIDEO" style="display: none;" autoplay></audio>
			<span class="nextPage" v-if="info.I_BUTTON_2!=''" @click="clickNext(info.I_BUTTON_2)">{{info.I_BUTTON_2}}</span>
		</div>
	</div>
</template>

<script>
	import DataRequestFactory from '@/factories/dataRequestFactory.js'
	import Footer from '../components/Footer.vue'
	import weui from 'weui.js'

	export default {
		name: '',
		data() {
			return {
				info: {
					dataList: []
				},
				I_PAGE_NO: '',
				I_PAGE_COUNT: '',
				I_BOOK_VIDEO: '',
				I_PAGE_VIDEO: '',
				searchInput: '', //上一页的搜索条件
				I_LEVEL_CODE: '', //上一页的搜索条件
				tabFlag: '', //上一页的搜索条件
				I_FLAG: '', //上一页的搜索条件

				dialog: "",
			}
		},
		components: {},
		created() {
			this.searchInput = this.$route.params.searchInput
			this.I_LEVEL_CODE = this.$route.params.I_LEVEL_CODE
			this.tabFlag = this.$route.params.tabFlag
			this.I_FLAG = this.$route.params.I_FLAG

			this.dialog = this.$route.query.idd
			console.log(this.dialog)
			if(this.dialog!=undefined){
				this.info.I_BOOK_NO_SYS = this.$route.query.id
			}else{
				this.info.I_BOOK_NO_SYS = this.$route.params.id
				this.I_PAGE_NO = this.$route.params.I_PAGE_NO
				if (this.info.I_BOOK_NO_SYS) {
					window.localStorage.setItem("H050030", this.info.I_BOOK_NO_SYS)
					window.localStorage.setItem("H050030_PageNo", this.I_PAGE_NO)
				} else {
					this.info.I_BOOK_NO_SYS = window.localStorage.getItem("H050030")
					this.I_PAGE_NO = window.localStorage.getItem("H050030_PageNo")
				}
			}


			let params = {
				I_BOOK_NO_SYS: this.info.I_BOOK_NO_SYS,
				"I_PAGE_NO": this.I_PAGE_NO,
				"I_BUTTON_NAME": "",
				"I_FLAG": this.dialog
			}

			DataRequestFactory.I050030(params).then((response) => {
				this.info = response
				this.I_PAGE_NO = response.I_PAGE_NO
				this.I_PAGE_COUNT = response.I_PAGE_COUNT
				this.I_BOOK_VIDEO = response.I_BOOK_VIDEO
				this.dialog=response.I_FLAG
				if (response.dataList.length > 0) {
					this.I_PAGE_VIDEO = response.dataList[0].I_SECTION_VIDEO
				}
			})
		},
		methods: {
			clickAudio(index) {
				let audio;
				if (index == '-1') {
					audio = document.getElementById('audio_00');
				} else if (index == '-2') {
					audio = document.getElementById('audio_top');
				} else {
					audio = document.getElementById('audio_' + index);
				}

				if (audio !== null) {
					if (audio.paused) {
						let audios = $("audio[id^=audio_]");
						for (let i = 0; i < audios.length; i++) {
							audios[i].pause();
						}
						$(".icon_play.active").removeClass("active")
						$(".icon_all_play.active").removeClass("active")
						$(".icon_top_play.active").removeClass("active")
						if (index == '-1') {
							$(audio).parent().find('.icon_all_play').addClass("active")
						} else if (index == '-2') {
							$(audio).parent().find('.icon_top_play').addClass("active")
						} else {
							$(audio).parent().find('.icon_play').addClass("active")
						}
						audio.play(); // 播放

						$(audio).bind('ended', function() {
							$(audio).parent().find('.play_btn').removeClass("active")
						});

					} else {
						if (index == '-1') {
							$(audio).parent().find('.icon_all_play').removeClass("active")
						} else if (index == '-2') {
							$(audio).parent().find('.icon_top_play').removeClass("active")
						} else {
							$(audio).parent().find('.icon_play').removeClass("active")
						}
						audio.pause(); // 暂停
					}
				}
			},
			clickPre(value) {
				$(".icon_play.active").removeClass("active")

				if (value == '返回封页') {
					this.$router.push({
						name: 'H050020',
						params: {
							id: this.info.I_BOOK_NO_SYS,
							searchInput: this.searchInput,
							I_LEVEL_CODE: this.I_LEVEL_CODE,
							I_FLAG: this.I_FLAG,
							tabFlag: this.tabFlag
						}
					})
				} else {
					let params = {
						I_BOOK_NO_SYS: this.info.I_BOOK_NO_SYS,
						"I_PAGE_NO": parseInt(this.I_PAGE_NO) - 1,
						"I_BUTTON_NAME": "",
						"I_FLAG": this.dialog
					}
					DataRequestFactory.I050030(params).then((response) => {
						this.info = response
						this.I_PAGE_NO = response.I_PAGE_NO
						this.I_PAGE_COUNT = response.I_PAGE_COUNT
						this.dialog=response.I_FLAG
						if (this.I_BOOK_VIDEO != response.I_BOOK_VIDEO) {
							this.I_BOOK_VIDEO = response.I_BOOK_VIDEO
						}
						if (response.dataList.length > 0) {
							this.I_PAGE_VIDEO = response.dataList[0].I_SECTION_VIDEO
							$(".icon_all_play").addClass("active")
						}
					})
				}
			},
			clickNext(value) {
				$(".icon_play.active").removeClass("active")

				if (value == '去测试') {
					this.$router.push({
						name: 'H050040',
						params: {
							id: this.info.I_BOOK_NO_SYS,
							searchInput: this.searchInput,
							I_LEVEL_CODE: this.I_LEVEL_CODE,
							I_FLAG: this.I_FLAG,
							tabFlag: this.tabFlag
						}
					})
				} else if (value == '返回') {
					this.$router.push({
						name: 'H050010',
						params: {
							searchInput: this.searchInput,
							I_LEVEL_CODE: this.I_LEVEL_CODE,
							I_FLAG: this.I_FLAG,
							tabFlag: this.tabFlag
						}
					})
				} else {
					let params = {
						I_BOOK_NO_SYS: this.info.I_BOOK_NO_SYS,
						"I_PAGE_NO": parseInt(this.I_PAGE_NO) + 1,
						"I_BUTTON_NAME": "",
						"I_FLAG": this.dialog
					}
					DataRequestFactory.I050030(params).then((response) => {
						this.info = response
						this.I_PAGE_NO = response.I_PAGE_NO
						this.I_PAGE_COUNT = response.I_PAGE_COUNT
						this.dialog=response.I_FLAG
						if (this.I_BOOK_VIDEO != response.I_BOOK_VIDEO) {
							this.I_BOOK_VIDEO = response.I_BOOK_VIDEO
						}
						if (response.dataList.length > 0) {
							this.I_PAGE_VIDEO = response.dataList[0].I_SECTION_VIDEO
							$(".icon_all_play").addClass("active")
						}
					})
				}
			}
		},
		mounted() {
			let screenHeight = window.innerHeight;
			let fontSize = getComputedStyle(window.document.documentElement)['font-size']
			let heightDiff = screenHeight - parseInt(fontSize) * 3
			$(".scroll_area").css("height", heightDiff + "px")

			setInterval(function() {
				$("#audio_00").bind('ended', function() {
					$(this).parent().find('.play_btn').removeClass("active")
				});
			}, 3000)
			// 子接收方式一参数

			// if(JSON.stringify(this.iframeData)!="{}"){
			// 	this.$router.push({name: 'H050030', params: {id: this.iframeData.id,dialog:"Y"}})
			// }

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	@import '../assets/css/pages/H050030.css';
	@import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H050030.vue